import { useEffect } from 'react';
import { Navigate } from 'react-router';

import { getImagoMpApiUrl, useValidateQuery } from 'src/apiClients';
import { Layout } from 'src/components/layout';
import { getIsProduction } from 'src/utils/get-is-production';
import { ROUTES } from 'src/utils/strings';

export const PerformLogin = () => {
    /*
     * This component is responsible for performing the login.
     * This behaviour is replicated from the old Imago Admin app.
     */

    const { isSuccess, isError } = useValidateQuery(undefined);
    const isProduction = getIsProduction();

    useEffect(() => {
        if (isProduction && isError) {
            window.location.replace(`${getImagoMpApiUrl()}enterprise/imagoadmin`);
        }
    }, [isError, isProduction]);

    if (isError) {
        if (isProduction) {
            return null;
        }
        return <Navigate to={ROUTES.LOGIN} state={{ isValidateError: isError }} replace />;
    }

    if (isSuccess) {
        return <Layout />;
    }

    return null;
};
